module.exports = __webpack_public_path__ + "static/img/6601_phase_function_Paper_PointsHejduk_Prediction.c49a6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6601_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 1dnz
// module chunks = 0